import { ActivityIndicator, Alert, Dimensions, Linking, Platform, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { ThemedText, ThemedView } from '@app/theme';
import { ThemedTouchableOpacity } from '@app/theme/Components';
import { useCameraFormat, type Camera as CameraType, type useCameraDevices as useCameraDevicesType   } from 'react-native-vision-camera';
import CameraIcon from "../../../../../assets/Icons/CameraIcon";

let Camera: typeof CameraType;
let useCameraDevices: typeof useCameraDevicesType;
let RNFS: any;

if (Platform.OS !== 'web') {
    const visionCamera = require('react-native-vision-camera');
    RNFS = require('react-native-fs');
    Camera = visionCamera.Camera;
    useCameraDevices = visionCamera.useCameraDevices;
}



const askForCameraPermission = async () => {
    const cameraPermission = await Camera.requestCameraPermission();

    if (cameraPermission === 'denied') {
        Alert.alert(
            'This feature requires camera access',
            'In iPhone settings, tap voltmoney and turn on camera',
            [
                {
                    text: 'Cancel',
                    onPress: () => { },
                    style: 'cancel',
                },
                {
                    text: 'Open Settings',
                    onPress: () => Linking.openSettings(),
                    style: 'cancel',
                },

            ],
            {
                cancelable: true,
                onDismiss: () =>
                    Alert.alert(
                        'This alert was dismissed by tapping outside of the alert dialog.',
                    ),
            },
        );
    }
}


const CameraPickerMobile = ({ onCancel , onCaptured , setCTALoader , previousPhoto , navigation , setRetriggerCamera , setOpenCamera }: {
    onCancel: () => void;
    onCaptured?: (imageData: string) => void;
    setCTALoader : (ctaLoader: boolean) => void
    previousPhoto?: string;
    navigation: any;
    setRetriggerCamera: (reTriggerCamera: boolean) => void;
    setOpenCamera: (openCamera: boolean) => void;
}) => {

    const device = useCameraDevices()
    const cameraDevice = device?.front;
    const camera = useRef<CameraType>(null)
    const [isLoading , setIsLoading] = useState(false)






    useEffect(() => {
        askForCameraPermission();
        setCTALoader(false)
    }, []);


    const onTakePhoto = async () => {
        setIsLoading(true)
        if (camera.current && cameraDevice) {
            try {
                const photo = await camera.current.takePhoto({
                    qualityPrioritization: 'speed',
                });
                if (RNFS) {
                    const imageUri = `file://${photo?.path}`;
                    const imageData = await RNFS.readFile(imageUri, 'base64');
                    if (onCaptured) {
                        onCaptured(imageData);
                    }
                    setOpenCamera(false)
                    setRetriggerCamera(false)
                    navigation.setParams({capturePhotoOnDeviation: false});
                }
            } catch (error) {
                Alert.alert('Error', 'Failed to take photo. Please try again.');
            } finally {
                setIsLoading(false)
            }
        } else {
            Alert.alert('Error', 'Camera is not available. Please check your permissions or device settings.');
        }
    };

    return (
        <View
            style={{
                height: Dimensions.get('window').height,
                backgroundColor: 'black',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {cameraDevice && (
                <Camera
                    ref={camera}
                    style={StyleSheet.absoluteFill}
                    device={cameraDevice}
                    isActive={true}
                    photo={true}
                    // format={}
                />
            )}
            {isLoading && (
				<ActivityIndicator
					size={42}
					color={'white'}
					style={{
						alignSelf: 'center',
						position: 'absolute',
					}}
				/>
			)}
            <ThemedTouchableOpacity onPress={onTakePhoto} borderRadius='full' borderWidth={1} borderColor='black' bottom={94} position='absolute' height={70} width={70} backgroundColor='white' />
            <ThemedTouchableOpacity onPress={() => {
                 if (previousPhoto && onCaptured) {
                     onCaptured(previousPhoto)
                 }
                 onCancel()
                 setRetriggerCamera(false)
                 navigation.setParams({capturePhotoOnDeviation: false});
            }} position='absolute' left={32} bottom={120}>
                <ThemedText color='white' variant='h5s'>Cancel</ThemedText>
            </ThemedTouchableOpacity>
        </View>
    )
}

export default CameraPickerMobile

const styles = StyleSheet.create({})